export const SUPER_BASE_URL = "/super-admin";

const SUPER_ROUTE_URLS = {
    HOME: `${SUPER_BASE_URL}/dashboard`,
    LOGIN: `${SUPER_BASE_URL}/login`,
    DPR: `${SUPER_BASE_URL}/daily-progress-report`,
    DMR: `${SUPER_BASE_URL}/daily-man-power`
}

export default SUPER_ROUTE_URLS;